import React, {Component} from "react";
import Loading from "../../components/Loading";
import {Link} from "react-router-dom";
import ObjectHelper from "../../helpers/ObjectHelper";
import Sport from "./modules/Sport";
import Leagues from "./modules/Leagues";
import {getLive} from "../../redux/actions/live";
import {connect} from "react-redux";
import lodash from "lodash";

class LiveContainer extends Component {
	state = {
		selected : {}
	};

	intervalId = 0;

	constructor(props) {
		super(props);
		this.checkEventHandler = this.checkEventHandler.bind(this);
		this.checkLeagueHandler = this.checkLeagueHandler.bind(this);
		this.selectAllHandler = this.selectAllHandler.bind(this);
	}

	componentWillMount() {
		if ( !this.props.live.isAlreadyLoaded ) {
			this.props.onGetLive();
		}

		this.intervalId = setInterval(this.props.onGetLive, 5000);
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
	}

	// выбрать отдельное событие
	checkEventHandler(e) {
		let selected = this.state.selected;
		const eventId = e.target.value;
		selected = ObjectHelper.toggleData(selected, eventId);
		this.setState({selected});
	}

	// выбрать все в турнире
	checkLeagueHandler(leagueId) {
		const {events} = this.props.live;
		let selected = this.state.selected;

		events.filter((event) => {return event.league_id === leagueId}).forEach((event) => {
			selected = ObjectHelper.toggleData(selected, event.id)
		});

		this.setState({selected});
	}

	// выбрать все
	selectAllHandler() {
		const {events} = this.props.live;
		let selected = this.state.selected;
		events.forEach((event) => {
			selected = ObjectHelper.toggleData(selected, event.id)
		});

		this.setState({selected});
	}

	render() {
		const {sports, events, leagues, results} = this.props.live;
		const {fetching} = this.props.live;
		const {selected} = this.state;

		// сортируем по алфавиту
		const sortedSports = lodash.sortBy(sports, i => i.name);

		const data = sortedSports.map((sport, index) =>
			<div key={`live-event-data-${index}`} className="live-event-data">
				<Sport key={`live-sport-${sport.id}`} sport={sport}/>

				<div className="events">
					<div className="events__table table-div">
						<Leagues
							key="live-leagues"
							leagues={leagues.filter((league) => {return league.sport_id === sport.id})}
							events={events.filter((event) => {return event.sport_id === sport.id})}
							checkLeague={this.checkLeagueHandler}
							checkEvent={this.checkEventHandler}
							results={results}
							selected={this.state.selected}
						/>
					</div>
				</div>
			</div>
		);

		return (
			<div key="live" className="body__container__side-right">
				<div className="live-event-header">
					<h1>Live</h1>
				</div>

				<div className="live-event-selector">
					<div className="buttons live-event-selector__buttons">
						<Link to={`/live/${ObjectHelper.join(selected, '-')}`} className="buttons__show gray">
							<span>Показать</span>
							<span className="sup">{ObjectHelper.count(selected)}</span>
						</Link>
						<button onClick={this.selectAllHandler} className="buttons__clear live-event-selector__buttons-select_all">
							Выбрать все
						</button>
					</div>
				</div>

				{fetching && <Loading/>}

				{data}
			</div>
		);
	}
}

export default connect(
	state => ({
		live : state.live
	}),
	dispatch => ({
		onGetLive : () => {
			dispatch(getLive());
		}
	})
)(LiveContainer);


// WEBPACK FOOTER //
// ./src/app/pages/Live/LiveContainer.js